import _regeneratorRuntime from "/Users/jacktiew/projects/vecloud-20250425/ve-cloud/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/jacktiew/projects/vecloud-20250425/ve-cloud/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/Users/jacktiew/projects/vecloud-20250425/ve-cloud/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import path from 'path-browserify';
import Fuse from 'fuse.js';
export var parseFireStoreDocument = function parseFireStoreDocument(doc) {
  var data = doc.data();
  Object.keys(data).forEach(function (key) {
    var value = data[key];

    if (value && value.toDate && value.toDate instanceof Function) {
      data[key] = value.toDate();
    }
  }); // React Admin requires an id field on every document,
  // So we can just using the firestore document id

  return _objectSpread({
    id: doc.id
  }, data);
};
export var parseDataAndUpload =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(ref, id, data) {
    var docPath;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (data) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", data);

          case 2:
            docPath = ref.doc(id).path;
            _context2.next = 5;
            return Promise.all(Object.keys(data).map(
            /*#__PURE__*/
            function () {
              var _ref2 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee(fieldName) {
                var val, isArray;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        val = data[fieldName];
                        isArray = Array.isArray(val);

                        if (!isArray) {
                          _context.next = 7;
                          break;
                        }

                        _context.next = 5;
                        return Promise.all(val.map(function (arrayObj, index) {
                          if (!!val[index] && val[index].hasOwnProperty('rawFile')) {
                            return Promise.all([parseDataField(val[index], docPath, fieldName + index)]);
                          } else {
                            return Promise.all(Object.keys(arrayObj).map(function (arrayObjFieldName) {
                              var arrayObjVal = arrayObj[arrayObjFieldName];
                              return parseDataField(arrayObjVal, docPath, fieldName + arrayObjFieldName + index);
                            }));
                          }
                        }));

                      case 5:
                        _context.next = 9;
                        break;

                      case 7:
                        _context.next = 9;
                        return parseDataField(val, docPath, fieldName);

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x4) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 5:
            return _context2.abrupt("return", data);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function parseDataAndUpload(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var parseDataField =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(ref, docPath, fieldPath) {
    var hasRawFile;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            hasRawFile = !!ref && ref.hasOwnProperty('rawFile');

            if (hasRawFile) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return");

          case 3:
            _context3.next = 5;
            return uploadAndGetLink(ref.rawFile, docPath, fieldPath);

          case 5:
            ref.src = _context3.sent;
            delete ref.rawFile;

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function parseDataField(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();
export var uploadAndGetLink =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(rawFile, docPath, fieldPath) {
    var storagePath, storageLink;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            storagePath = path.join(docPath, fieldPath);
            _context4.next = 3;
            return saveFile(storagePath, rawFile);

          case 3:
            storageLink = _context4.sent;
            return _context4.abrupt("return", storageLink);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function uploadAndGetLink(_x8, _x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();
export var saveFile =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(storagePath, rawFile) {
    var task, taskResult, getDownloadURL;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            task = firebase.storage().ref(storagePath).put(rawFile);
            _context5.prev = 1;
            _context5.next = 4;
            return new Promise(function (res, rej) {
              return task.then(res).catch(rej);
            });

          case 4:
            taskResult = _context5.sent;
            _context5.next = 7;
            return taskResult.ref.getDownloadURL();

          case 7:
            getDownloadURL = _context5.sent;
            return _context5.abrupt("return", getDownloadURL);

          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](1);

            if (!(_context5.t0.code === 'storage/unknown')) {
              _context5.next = 17;
              break;
            }

            throw Error('saveFile() error saving file, No bucket found! Try clicking "Get Started" in firebase -> storage', {
              storageError: _context5.t0
            });

          case 17:
            throw Error('saveFile() error saving file', {
              storageError: _context5.t0
            });

          case 18:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 11]]);
  }));

  return function saveFile(_x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();
export var flattenObject = function flattenObject(ob) {
  var toReturn = {};

  for (var i in ob) {
    if (!ob.hasOwnProperty(i)) continue;

    if (typeof ob[i] == 'object' && ob[i] !== null) {
      var flatObject = flattenObject(ob[i]);

      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;
        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      toReturn[i] = ob[i];
    }
  }

  return toReturn;
};
export var deepSearch = function deepSearch(searchValue, data) {
  searchValue = searchValue.toLowerCase();
  return data.filter(function (item) {
    var flatten = flattenObject(item);
    var values = Object.values(flatten);

    for (var i = 0; i < values.length; i++) {
      var value = values[i];

      if (['string', 'number'].includes(typeof varlue)) {
        value = (value + '').toLowerCase();

        if (value.search(searchValue) >= 0) {
          return true;
        }
      }
    }

    return false;
  });
};
export var fuseSearch = function fuseSearch(searchValue, searchKeys, data) {
  var options = {
    minMatchCharLength: 3,
    keys: searchKeys,
    useExtendedSearch: true
  };
  var fuse = new Fuse(data, options);
  var results = fuse.search("'" + searchValue).map(function (_ref6) {
    var item = _ref6.item;
    return item;
  });
  return results;
};